module.exports = __webpack_public_path__ + "static/media/attribute_hp_regen.e3db37c8.png";